// No-op for web - IntelliProve listener is only needed on native
export const useIntelliProveListener = () => {
  // No listener needed on web
};
